module.exports = __webpack_public_path__ + "img/rec-title-2.5e850d2.png";